import * as types from '../actions/actionTypes';
import initialState from './initialState';
import moment from 'moment'


export default function teacherInfoReducer(state = initialState.teacherInfo, action) {
  switch (action.type) {
    case types.SET_TEACHER_INFO:
      return Object.assign({}, state, action.teacherInfo);
    case types.RESET_TEACHER_INFO:
      return Object.assign({}, state,  initialState.teacherInfo)
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/teacherInfoReducer.js